import { useEffect, useState } from "react";
import { getPageBySlug, WPPage } from "../content/contentClient";

type UseWPPageResult = {
  page: WPPage | null;
  loading: boolean;
  notFound: boolean;
};

const DEFAULT_SLUG_BY_LANG: Record<string, string> = {
  de: "start",
  en: "home"
};

const normalizeSlug = (raw?: string, lang?: string) => {
  if (!raw || raw.trim().length === 0) {
    return DEFAULT_SLUG_BY_LANG[lang || "de"] || "start";
  }
  const parts = raw.split("/").filter(Boolean);
  return parts[parts.length - 1] || DEFAULT_SLUG_BY_LANG[lang || "de"] || "start";
};

export default function useWPPage(slug?: string, lang?: string): UseWPPageResult {
  const [page, setPage] = useState<WPPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const activeSlug = normalizeSlug(slug, lang);

    const loadPage = async () => {
      setLoading(true);
      setNotFound(false);

      try {
        const data = await getPageBySlug(activeSlug, lang);
        if (!data) {
          setNotFound(true);
          setPage(null);
          return;
        }
        setPage(data);
      } catch (error) {
        setNotFound(true);
        setPage(null);
      } finally {
        setLoading(false);
      }
    };

    loadPage();
  }, [slug, lang]);

  return { page, loading, notFound };
}
